<template>
  <base-button class="submit-button"
               v-bind="$attrs"
               v-on="$listeners">
    <slot>
      {{$t('generic.save')}}
    </slot>
  </base-button>
</template>
<script>
  export default {
    name: 'submit-button',
    inheritAttrs: false
  }
</script>
<style scoped>
  .submit-button {
    min-width: 150px;
  }
</style>
